import React from 'react';
import PropTypes from 'prop-types';
import { Title, TitleSizes } from '@patternfly/react-core';
import Undrafted from './Undrafted';

/*
  The PatternFly grid system works great for layouts, but there's trouble here with
  the large draft tables because the grid will set the max height to the height of
  the tallest component. Here we want to make sure the undrafted-all table scrolls
  when overflowing, with a max-height of whatever the undrafted position tables are.

  As a hack, we will wait for the undrafted-positions grid to be generated,
  and then set the height of the table to be equal to that minus the header. To
  ensure that the values are populated, we wait until the height is not undefined.
*/
function resizeUndraftedTable(): void {
  const gridHeight = document.getElementById('undrafted-positions')?.clientHeight;
  const undraftedHeaderHeight = document.getElementById('undrafted-header')?.clientHeight;
  const draftedHeaderHeight = document.getElementById('drafted-header')?.clientHeight;
  const undraftedTable = document.getElementsByClassName('undrafted-table')[0] as HTMLElement | null;
  const draftedTable = document.getElementsByClassName('drafted-table')[0] as HTMLElement | null;
  if (
    gridHeight != null &&
    undraftedTable != null &&
    draftedTable != null &&
    undraftedHeaderHeight != null &&
    draftedHeaderHeight != null
  ) {
    undraftedTable.style.height = gridHeight / 2 - undraftedHeaderHeight + 'px';
    draftedTable.style.height = gridHeight / 2 - draftedHeaderHeight + 'px';
  }
}

function UndraftedAll(props) {
  (async () => {
    while (document.getElementById('undrafted-positions')?.clientHeight == undefined) {
      await new Promise((resolve) => setTimeout(resolve, 250));
    }
    resizeUndraftedTable();
  })();
  window.addEventListener('resize', resizeUndraftedTable);
  return (
    <div id="undrafted-all">
      <div id="undrafted-header">
        <Title headingLevel="h1" size={TitleSizes.lg}>
          Expert Concensus Rankings
        </Title>
        <input
          type="text"
          className="form-control player-search"
          placeholder="Search.."
          onChange={props.search}
          value={props.query}
        />
      </div>
      <div className="undrafted-table">
        <Undrafted
          fields={['rank', 'tier', 'position', 'name', 'team', 'bye_week']}
          players={props.players}
          draft={(p) => props.draft(p)}
        />
      </div>
    </div>
  );
}

UndraftedAll.propTypes = {
  players: PropTypes.array.isRequired,
  draft: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  search: PropTypes.func.isRequired,
  format: PropTypes.func
};

export default UndraftedAll;
